module.exports = __webpack_public_path__ + "static/media/cardFive.6a5a1656.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowTwo/cardFive.jpg
// module id = 18
// module chunks = 0